module.exports = __webpack_public_path__ + "media/images/card_visa-ee62d40ff194314bc70e2bf64b1ed496.svg";